<template>
  <div class="animated fadeIn">
    <h2>Detail Downtime</h2>
    <p>Customer : {{detail.cust_acc_name}}</p>
    <p>Alamat : {{detail.installation_address}}</p>
    <p>Tanggal Aktivasi : {{detail.cust_activation_date}}</p>
    <table class="table table-bordered">
      <thead>
      <tr>
        <th>No</th>
        <th>DownTime</th>
        <th>Durasi</th>
        <th>Notes</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(downtime, i) in detail.data">
        <tr>
          <td>{{i + 1}}</td>
          <td> {{downtime.start_time}}</td>
          <td>{{downtime.duration | convertSecond}}</td>
          <td>{{downtime.problem + ' ' + downtime.cause}} </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    props: {
      detail: {
        type: Object,
        default: {
          cust_acc_name: '',
          installation_address: '',
          cust_activation_date: '',
          data: []
        }
      }
    }
  }
</script>
